import { Modal as MUIModal, Card, styled, makeStyles } from '@mui/material';

export const Modal = ({ children, ...rest }) => {
  return (
    <MUIModal
      {...rest}
      sx={{ overflowY: 'scroll', margin: 'auto', left: '50%', transform: 'translateX(-50%)', width: '100%' }}
    >
      {children}
    </MUIModal>
  );
};

export const ModalBody = styled(Card)`
  max-width: 500px;
  width: 100%;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin: auto;
  height: 80vh;
  overflow: scroll;
  top: 50%;
  transform: translateY(-50%);
`;
